import React from 'react';
import styled from 'styled-components';

interface PaginationProps {
  totalPages: number;
  currentPage: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ totalPages, currentPage, onPageChange }) => {
  const getPageNumbers = () => {
    const pages: (number | string)[] = [];
    
    pages.push(1);
    
    if (currentPage > 3) {
      pages.push('...');
    }
    
    if (currentPage > 2) {
      pages.push(currentPage - 1);
    }
    
    if (currentPage !== 1 && currentPage !== totalPages) {
      pages.push(currentPage);
    }
    
    if (currentPage < totalPages - 1) {
      pages.push(currentPage + 1);
    }
    
    if (currentPage < totalPages - 2) {
      pages.push('...');
    }

    if (totalPages > 1) {
      pages.push(totalPages);
    }
    
    return pages;
  };

  return (
    <PaginationContainer>
      <PaginationButton 
        onClick={() => onPageChange(1)} 
        disabled={currentPage === 1}
      >
        &lt;&lt;
      </PaginationButton>
      
      <PaginationButton 
        onClick={() => onPageChange(currentPage - 1)} 
        disabled={currentPage === 1}
      >
        &lt;
      </PaginationButton>
      
      {getPageNumbers().map((page, index) => (
        <PaginationButton
          key={`${page}-${index}`}
          onClick={() => typeof page === 'number' ? onPageChange(page) : undefined}
          className={currentPage === page ? 'active' : ''}
          disabled={typeof page === 'string'}
        >
          {page}
        </PaginationButton>
      ))}
      
      <PaginationButton 
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        &gt;
      </PaginationButton>
      
      <PaginationButton 
        onClick={() => onPageChange(totalPages)}
        disabled={currentPage === totalPages}
      >
        &gt;&gt;
      </PaginationButton>
    </PaginationContainer>
  );
};

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 20px;
  flex-wrap: wrap;
  padding: 0 10px;
`;

const PaginationButton = styled.button`
  padding: 8px 12px;
  border: 1px solid #ddd;
  background: white;
  cursor: pointer;
  min-width: 40px;
  border-radius: 4px;
  
  &:disabled {
    background: #f5f5f5;
    cursor: not-allowed;
  }
  
  &.active {
    background: #DC1E2D;
    color: white;
    border-color: #DC1E2D;
  }

  @media (max-width: 768px) {
    padding: 6px 10px;
    min-width: 36px;
  }
`;

export default Pagination;